import React from 'react';
import {
  useReactTable,
  createColumnHelper,
  getCoreRowModel,
} from '@tanstack/react-table';

import { formatNumberConsiderZero } from "../../../../utils/utils";

const App = (props) => {
  const { columnsData, tableData, tableName, onActionClick, viewReport } = props;

  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.accessor('descricao', {
      id: 'descricao', // Provide unique id for 'descricao' column
      header: tableName, // Check if tableName is an object and convert it to string
      cell: info => {
        const value = info.getValue();
        return <div style={{ textAlign: 'left' }}>{typeof value === 'object' ? JSON.stringify(value) : value}</div>;
      },
    }),
    columnHelper.accessor('amount', {
      id: 'amount', // Provide unique id for 'amount' column
      header: '', // No header for 'amount' column
      cell: info => {
        const value = info.getValue();
        const formattedValue = formatNumberConsiderZero(value);
        return <div style={{ textAlign: 'right' }}>{typeof value === 'object' ? JSON.stringify(formattedValue) : formattedValue}</div>;
      },
    }),
  ];

  const table = useReactTable({
    data: tableData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div>
      <table
        border="1"
        style={{
          borderCollapse: 'collapse',
          width: '100%',
          border: '1px solid black',
        }}
      >
        <thead>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header, index) => (
                <th
                  key={header.id}
                  colSpan={header.colSpan}
                  style={{
                    padding: '4px',
                    textAlign: 'right',
                    fontSize: '14px',
                    backgroundColor: '#f0f0f0',
                    borderBottom: '1px solid #000',
                    width: '50%', // Ensure columns are fixed to 50% of the table width
                  }}
                >
                  {header.isPlaceholder ? null : header.column.columnDef.header}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map(row => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell, index) => (
                <td
                  key={cell.id}
                  style={{
                    padding: '4px',
                    textAlign: 'center',
                    fontSize: '12px',
                    borderBottom: '1px solid #000',
                    borderRight: index < row.getVisibleCells().length - 1 ? '1px solid #000' : '',
                    width: '50%', // Ensure columns are fixed to 50% of the table width

                  }}
                >
                  {cell.column.columnDef.cell?.(cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default App;
